import tree from '@/components/tree.vue'
import DelData from '@/components/delToast.vue'
import { dqgj } from '@/axios'
import Page from '@/components/page.vue'
import Linkwin from '../components/link_win.vue'
import { Message } from 'element-ui'
import myTables from '@/components/tables/tables.vue'
let that;
export default{
	data(){
		return{
			getdata:{
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				tid:2,//服务互助 
				title:"",
				year:'',
				month:"",
				page:1,
			},
			tableHeader: [     // 表头
				{prop: 'sz_img', label: '封面',width:'140'},
				{prop: 'title', label: '标题',width:""},
				{prop: 'class_id', label: '分类',width:"80",formatData:(val) => {
					if(val == 1){
						return '党员帮扶'
					}else if(val == 2){
						return '志愿活动'
					}else{
						return '未知分类'
					}
				}},
				{prop: 'k_time', label: '发布时间',width:"160"},
				// 操作栏
				{
					prop: 'oper', label: '操作', fixed: 'right', width: '125',
					oper: [
						{name: "详情", style: {color:'#bb0000'}, clickFun: this.detail},
						{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit},
						{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
					]
				}
			],
			delList:[],
			tableData:[],
			totalPage:0,
		}
	},
	components:{tree,Page,DelData,Linkwin,myTables},
	methods:{
		// 数据
		dataList(){
			dqgj.dqgjList(that.getdata).then(res => {
				that.tableData = res.data.pagedata;
				that.totalPage = res.data.count;
			})
		},
		// 一键删除
		selectList(val){
			that.delList = val;
		},
		delAll(){
			if(that.delList.length == 0){
				Message.warning('请先选择要删除得数据')
			}else{
				that.delData();
			}
		},
		//	删除操作
		delData(){
			that.$refs.delDatas.showToast(res => {
				if(res){
					dqgj.dqgjDel({
						id:that.delList,
					}).then(res => {
						if(res.code == 200){
							Message({
								type: 'success',
								message: '删除成功!'
							})
						}else{
							Message({
								type: 'error',
								message: res.msg
							})
						}
						that.getdata.page = 1;
						that.dataList();
					})
				}
			})
		},
		del(data){
			that.delList = [data.id]
			that.delData();
		},
		add(){
			//新增
			that.$router.push({
				path:'/fwhz_add',
				query:{
					type:'add',
				},
			})
		},
		edit(data){
			//编辑
			that.$router.push({
				path:'/fwhz_add',
				query:{
					id:data.id,
					flag:data.flag,
					type:'edit',
				},
			})
		},
		detail(data){
			// 详情
			that.$router.push({
				path:"/fwhz_detail",
				query:{
					id:data.id,
					flag:data.flag
				}
			})	
		},
		// 分页筛选
		changedata(current){
			that.getdata.page = current;
			that.dataList();
		},
		// 树形结构筛选
		treeSelect(data){
			that.getdata.user_id = data.id;
			that.getdata.flag = data.flag;
			that.getdata.page = 1;
			that.dataList();
		}
	},
	mounted() {
		that.dataList();
	},
	created() {
		that = this;
		that.$emit('selectTop',2)
	}
}